import { BaasicApp } from 'baasic-sdk-reactjs';
import { baasicOptions } from 'common/infrastructure';

class BaasicAppFactory {
    constructor(options) {
        this.options = options;
    }

    create(apiKey) {
        // `baasicKeyHandler` never existed in core/utils — the old CJS interop
        // passed keyGenerator: undefined and the SDK fell back to its default.
        return new BaasicApp(apiKey, {
            ...this.options
        });
    }
}

const baasicAppFactory = new BaasicAppFactory(baasicOptions);
export default baasicAppFactory;